import "./GoverningBodies.scss";
import administration from "../../Administration.json";
import AboutUsDynamicPage from '../../../AboutUs/AboutUs Dynamic Page/AboutUsDynamicPage';
import TableComponent from '../../../components/Table/TableComponent';

const GoverningBodies = () => {

    const governingBodyPage = administration.governingBodies[0];
    const columns = ["S.No.", "Name", "Designation"];
    const rows = [
        { name: "Shri. M. S. Faizal Khan", designation: "President" },
        { name: "Janab Dr. A. P. Majeed Khan", designation: "Secretary" },
        { name: "Mrs. Saifunissa", designation: "Member" },
        { name: "Mr. Abdul Khader", designation: "Member" },
        { name: "Mrs. Ansa Shabnam", designation: "Member" },
        { name: "Mr. Shafeek Salim", designation: "Member" },
        { name: "Mrs. Sainabha", designation: "Member" }
    ];

    return (
        <section className="governingBodiesMainContainer">
            <AboutUsDynamicPage
                title={governingBodyPage.title}
                content={governingBodyPage.content}
            />
            <TableComponent
                columns={columns}
                data={rows}
                title="Governing Bodies Members"
                gap='20px'
            />
        </section>
    )
}

export default GoverningBodies
